import { toast } from "react-toastify";
import { _DodoDocs } from "../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { PrintJson } from "../../../../theme/Component/PrintJson";
import { useEffect, useState } from "react";

export const RadicateForm = () => {

    const { instance, lista, setLista, bean, setBean, handleChange } = useDataBean(_DodoDocs);


    const [inputs, setInputs] = useState<any>([]);
    const [required, setRequired] = useState<any>([]);

    useEffect(() => {
        if (inputs.length > 0) {

        }
    }, [inputs])

    const getRenderFormInputs = () => {
        if (bean.formCode) {
            instance.getRenderFormInputs(bean.formCode + "").then(
                (resp: any) => {

                    if (resp.Column) {
                        if (resp.Column.length > 0) {
                            setInputs(resp.Column);
                        } else {
                            setInputs([]);
                        }
                    }

                }
            )
        } else {
            toast.warning("Codigo de formulario no valido");
        }
    }

    const renderFiel = (row: any) => {


        console.log(row);

        if (row.DataBeanProperties.LinkTo != '-1') {
            return (
                <div className="col-md-6">
                    <label>{row.DataBeanProperties.Name} {row.DataBeanProperties.Required ? '*' : ''}</label>
                    <select name={row.DataBeanProperties.Column} value={bean[row.DataBeanProperties.Column]} onChange={handleChange} className="form-select">
                        <option value="">...</option>
                        {Array.isArray(row.DataBeanProperties?.Options) &&
                            <>
                                {
                                    row.DataBeanProperties.Options.map((opt: any, index: number) => {
                                        return (
                                            <option value={opt.DataBeanProperties.Text}>{opt.DataBeanProperties.Text}</option>
                                        )
                                    })
                                }
                            </>
                        }
                    </select>
                </div>
            )

        } else {
            return (
                <div className="col-md-6">
                    <label>{row.DataBeanProperties.Name} {row.DataBeanProperties.Required ? '*' : ''}</label>
                    <input type="text" className="form-control" name={row.DataBeanProperties.Column} value={bean[row.DataBeanProperties.Column]} onChange={handleChange} />
                </div>
            )
        }

    }

    return (
        <div className="row">
            <div className="col-md-2">
                <label>No Formulario</label>
                <input type="text" name="formCode" className="form-control" value={bean.formCode} onChange={handleChange} />
            </div>
            <div className="col-md-2">
                <BasicButton icon="ri-file-search-fill" clase="primary mbtn" eventClick={getRenderFormInputs}>Cargar</BasicButton>
            </div>
            <div className="col-md-12">
                <div className="row">
                    {inputs.map((row: any, index: number) => {
                        return (
                            <>
                                {renderFiel(row)}
                            </>
                        )
                        // return (
                        //     <div className="col-md-6">
                        //         <label>{row.DataBeanProperties.Name} {row.DataBeanProperties.Required ? '*' : ''}</label>
                        //         <input type="text" className="form-control" name={row.DataBeanProperties.Column} value={bean[row.DataBeanProperties.Column]} onChange={handleChange} />
                        //     </div>
                        // )
                    })}
                </div>
                <PrintJson json={bean} />

            </div>
        </div>
    )
}